<template>
  <div class="page sizeA4">
    <h4 class="text-center m-3">Edital de Convocação - Assembleia</h4>
    <p class="text-center m-3">Leia até o final e clique em "Ciente"</p>
    <div class="row">
      <div class="termo-container">
        <PDFViewer :source="urlTermo" class="termo-embed" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="d-flex justify-content-end">
        <b-button variant="success" @click="aceitar()">
          <i class="mdi mdi-check font-size-16 align-middle"></i>
          Ciente
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

export default {
  components: {
    PDFViewer
  },
  data() {
    return {
      user: {},
      urlTermo: "",
      isMobile: false,
    };
  },

  created() {
    this.user = this.$store.state.me;
    this.buscarTermo();
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },

    buscarTermo() {
      this.loading = true;
      // const token = this.$store.state.access_token;
      const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
      const id = this.$route.params.id;
      if (isErp) {
        this.loading = false;
        this.$router.push("/");
        return;
      }
      if (!id) {
        this.loading = false;
        return;
      }
      const endpoint = "api/reuniao/buscarTermo/" + id;
      this.$http
        .get(endpoint, {
          responseType: "blob",
        })
        .then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          this.urlTermo = window.URL.createObjectURL(blob);
        });
    },

    aceitar() {
      this.$http
        .get("api/reuniao/aprovarTermo/" + this.$route.params.id)
        .then(async (response) => {
          if (!response.data.message) {
            await this.verificaDocumentoAssembleia();
          } else {
            this.$tools.alerta(response.data.message, "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$tools.alerta(err.response.data.message, "error");
        });
    },

    async verificaDocumentoAssembleia() {
      this.$http
        .get("api/reuniao/verificarTermo")
        .then(async (response) => {
          const sq_upload = response.data.sq_upload;
          // Só redireciona para /termo/assembleia/ se sq_upload for válido
          // Só redireciona para /termo/assembleia/ se sq_upload for um valor numérico válido
          if (sq_upload !== null && sq_upload !== undefined && sq_upload !== '' && sq_upload !== 'null' && !isNaN(Number(sq_upload))) {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", false);
            this.$store.commit("TERMO_ASSEMBLEIA", sq_upload);
            this.$router.push("/termo/assembleia/" + sq_upload);
          } else {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
          this.$router.push("/");
        });
    },
  },
};
</script>
<style scoped>
/* Responsividade para o termo, título e centralização do embed */
h4.text-center.m-3 {
  word-break: break-word;
  white-space: normal;
  text-align: center;
  width: 100%;
  max-width: 100vw;
  font-size: 1.2rem;
  margin-left: auto !important;
  margin-right: auto !important;
}
.d-flex.justify-content-center {
  justify-content: center !important;
  align-items: center;
  width: 100%;
}
.termo-embed {
  height: 60vh;
  width: 100%;
  max-width: 800px;
  min-height: 300px;
  border: none;
  display: block;
  margin: 0 auto;
}
.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media (max-width: 768px) {
  .page.sizeA4 {
    padding: 8px 4px !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
  }

  h4.text-center.m-3,
  p.text-center.m-3 {
    padding: 0 2px !important;
  }

  .d-flex.justify-content-center {
    width: 100% !important;
    justify-content: center !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .termo-embed {
    height: 55vh;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    display: block;
  }

  .d-flex.justify-content-end {
    justify-content: center !important;
    width: 100% !important;
  }

  .m-3 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>